/* eslint-disable import/order */
/* eslint-disable arrow-body-style */
import { motion } from 'framer-motion';
import { Header, Container, ExportReportWrapper } from '../../styles/shared/styles';
import AttendancePresencialReportTableList from '../../components/AttendancePresencialReport/table';
import useSWR from 'swr';
import { variantFetcher } from '../../service/SWRFetcher';
import { useEffect, useState } from 'react';
import { TablePagination } from '@material-ui/core';
import useApp from '../../hooks/useApp';
import Filter from '../../components/AttendancePresencialReport/filter';
import { format } from 'date-fns';
import { DateTime } from 'luxon';
import SummaryReportTable from '../../components/AttendancePresencialReport/summaryReportTable';

const AttendancePresencialReport = () => {
  const { setState } = useApp();

  const [filters, setFilters] = useState({
    date_start: DateTime.now().plus({ months: -1 }).toISODate(),
    date_end: DateTime.now().toISODate(),
    partners: [],
    brokers: [],
    client: '',
  });

  const [pages, setPages] = useState({
    per_page: 10,
    page: 0,
  });

  const {
    data: presencialLeads,
    mutate,
    isValidating,
  } = useSWR(
    `/leads/list-presencial?page=${pages?.page}&per_page=${pages?.per_page}&date_start=${filters?.date_start}&date_end=${filters?.date_end}&partners=${filters?.partners}&brokers=${filters?.brokers}&client=${filters?.client}`,
    variantFetcher,
    {
      revalidateOnFocus: false,
    }
  );

  const handleChangePage = (event, newPage) => {
    setPages({ ...pages, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setPages({ ...pages, page: 0, per_page: parseInt(event.target.value, 10) });
    mutate();
  };

  useEffect(() => {
    setState('loading', isValidating);
  }, [isValidating]);

  return (
    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
      <Container style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Header>
          <h1>Relatório de Diagnostico Presencial</h1>
        </Header>

        <Filter filtersParams={filters} setFiltersParams={setFilters} />

        {!isValidating && <SummaryReportTable listItem={presencialLeads?.summaryReport} />}

        {!isValidating && (
          <TablePagination
            component="div"
            count={presencialLeads?.meta?.total || 0}
            page={pages.page || 0}
            onPageChange={handleChangePage}
            rowsPerPage={pages.per_page || 0}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}

        {!isValidating && <AttendancePresencialReportTableList listItem={presencialLeads?.data} />}
      </Container>
    </motion.div>
  );
};

export default AttendancePresencialReport;
